import React, { useState, useEffect, useRef } from 'react';

const PageTransition = ({ children, transitionKey, className = '' }) => {
  const [isVisible, setIsVisible] = useState(false);
  const [isExiting, setIsExiting] = useState(false);
  const [content, setContent] = useState(children);
  const [pendingContent, setPendingContent] = useState(null);
  const containerRef = useRef(null);

  useEffect(() => {
    if (transitionKey !== undefined) {
      if (isVisible) {
        // Start exit transition
        setIsExiting(true);
        setPendingContent(children);
        
        // After exit transition completes, switch content
        const exitTimeout = setTimeout(() => {
          setContent(children);
          setIsExiting(false);
          setIsVisible(false);
          
          // Small delay to ensure DOM update, then start enter transition
          const enterTimeout = setTimeout(() => {
            setIsVisible(true);
          }, 10);
          
          return () => clearTimeout(enterTimeout);
        }, 200); // Match the exit transition duration
        
        return () => clearTimeout(exitTimeout);
      } else {
        // Initial load or enter transition
        setContent(children);
        setIsVisible(true);
      }
    }
  }, [transitionKey, children]);

  // Handle initial mount
  useEffect(() => {
    if (transitionKey !== undefined) {
      const initialTimeout = setTimeout(() => {
        setIsVisible(true);
      }, 10);
      return () => clearTimeout(initialTimeout);
    }
  }, []);

  const getPageClassName = () => {
    let classes = 'page-content';
    if (isVisible && !isExiting) {
      classes += ' active';
    } else if (isExiting) {
      classes += ' exiting';
    }
    if (className) {
      classes += ` ${className}`;
    }
    return classes;
  };

  return (
    <div className="page-transition-container" ref={containerRef}>
      <div className={getPageClassName()}>
        {content}
      </div>
    </div>
  );
};

export default PageTransition; 